import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import ContactForm from "./sections/ContactForm";
import ContactDetails from "./sections/ContactDetails";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactHero />
      <ContactDetails />
      <ContactForm />
      <Footer />
    </div>;
}